import { create } from "zustand";

export const useAppStatusStore = create((set) => ({
  isOnline: typeof navigator !== "undefined" ? navigator.onLine : true,
  lastOfflineAt: null,

  // banner UX
  isOfflineBannerDismissed: false,
  dismissOfflineBanner: () => set({ isOfflineBannerDismissed: true }),
  undismissOfflineBanner: () => set({ isOfflineBannerDismissed: false }),

  setOnline: () =>
    set({
      isOnline: true,
    }),

  setOffline: () =>
    set({
      isOnline: false,
      lastOfflineAt: Date.now(),
      isOfflineBannerDismissed: false, // auto-show again on a new offline event
    }),
}));
